/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const AlertFill = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m12.87 3 9.52 16.5a1 1 0 0 1-.86 1.5H2.47a1 1 0 0 1-.86-1.5L11.13 3a1 1 0 0 1 1.74 0M11 16v2h2v-2zm0-7v5h2V9z" />
  </Icon>
);
